module.exports = __webpack_public_path__ + "img/hockey-stick-puck.baf3931d.svg";